import {
	OnboardingGetStartedStep,
	onboardingGetStartedSteps,
	OnboardingProgramQuickstartStep,
	onboardingProgramQuickstartSteps,
	OnboardingStatus,
	OnboardingStepStatus,
	OnboardingType,
} from "@domain/onboarding/onboarding";
import { isNotNil } from "@utils/assert";

export const MINIMAL_EXERCISES_IN_PROGRAM = 4;

export const initOnboardingGetStartedSteps = (
	status: OnboardingStatus,
): Record<OnboardingGetStartedStep, OnboardingStepStatus> => {
	const record = Object.fromEntries(
		onboardingGetStartedSteps.map(key => [key, OnboardingStepStatus.AVAILABLE]),
	) as Record<OnboardingGetStartedStep, OnboardingStepStatus>;

	onboardingGetStartedSteps.forEach(step => {
		const dismissedStatus = status[OnboardingType.GET_STARTED].find((s: { step: OnboardingGetStartedStep }) => s.step === step);

		if (isNotNil(dismissedStatus)) {
			record[step] = OnboardingStepStatus.DISMISSED;
		}
	});

	return record;
};

export const initOnboardingProgramQuickstartSteps = (
	status: OnboardingStatus,
): Record<OnboardingProgramQuickstartStep, OnboardingStepStatus> => {
	const record = Object.fromEntries(
		onboardingProgramQuickstartSteps.map(key => [key, OnboardingStepStatus.AVAILABLE]),
	) as Record<OnboardingProgramQuickstartStep, OnboardingStepStatus>;

	onboardingProgramQuickstartSteps.forEach(step => {
		const dismissedStatus = status[OnboardingType.PROGRAM_QUICKSTART].find((s: { step: OnboardingProgramQuickstartStep }) => s.step === step);
		if (isNotNil(dismissedStatus)) {
			record[step] = OnboardingStepStatus.DISMISSED;
		}
	});

	return record;
};
